const requireComponent = require.context("./", false, /\w+\.vue$/);
const baseIcons = {};

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const name = fileName
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");
  const options = componentConfig.default || componentConfig;
  baseIcons[name] = options;
});

export default {
  ...baseIcons
};
